import { Formik, Form, Field, ErrorMessage } from "formik";
import Button from "../../button/button.component";
import {
    CMHeadingContainer,
    CMBox,
    CMOffer,
    CMOrderDetails,
} from "./order-preview.styles";
import Image, { IMAGE_TYPE } from "../../image/image.component";
import Dropdown from "../../../components/dropdownOrder/dropdownOrder.component";
import * as Yup from "yup";
import {
    countDecimal,
    expoToString,
    getTotalValue,
    isNumber,
    isNumberWithoutDot,
    toFix,
    truncateToDecimals,
} from "../../../Utils/common.utils";
import { useEffect, useRef, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import "./OrderPreview.scss"
import { time } from "highcharts";
import { setPairNotify } from "../../../Services/prod/auth.service";
import { toast } from "react-toastify";

const IssuerOrder = ({
    handleNext,
    auction,
    editValues,
    pairBalance,
    pairFees,
    issuerData,
    side,
    setSide,
    isEdit,
    setActiveStep,
    getPairNotification
}) => {
    const formRef = useRef();


    const priceDecimalLimit = 2;
    const options = [
        { value: 0, description: "Buy", text: "Buy" },
        { value: 1, description: "Sell", text: "Sell" },
    ];

    const timePeriodOptions = [
        { description: '1 Month', value: 1, text: '1 Month' },
        { description: '2 Months', value: 2, text: '2 Months' },
        { description: '3 Months', value: 3, text: '3 Months' },
        { description: '4 Months', value: 4, text: '4 Months' },
        { description: '5 Months', value: 5, text: '5 Months' },
        { description: '6 Months', value: 6, text: '6 Months' },
        { description: '7 Months', value: 7, text: '7 Months' },
        { description: '8 Months', value: 8, text: '8 Months' },
        { description: '9 Months', value: 9, text: '9 Months' },
        { description: '10 Months', value: 10, text: '10 Months' },
        { description: '11 Months', value: 11, text: '11 Months' },
        { description: '1 Year', value: 12, text: '1 Year' },
        { description: '2 Years', value: 24, text: '2 Years' },
        { description: '3 Years', value: 36, text: '3 Years' },
        { description: '4 Years', value: 48, text: '4 Years' },
        { description: '5 Years', value: 60, text: '5 Years' },
    ];
    const validationSchema = Yup.object({
        side: Yup.number().required("Please select an option"),
        time: Yup.number().required('Time Period is Required'),
        amount: Yup.number()
            .test('amount', "Amount can't be empty", function (value) {
                const units = this.parent.units;
                // Allow 0 in 'amount' if 'units' has a valid value
                return (units && units.length > 0) || value !== undefined;
            })
            .test('isPositive', 'Enter a valid amount', function (value) {
                const units = this.parent.units;
                // Allow 0 if units has a value, otherwise check if value is positive
                return (units && units.length > 0) || value > 0;
            })
            .test('Is less than 3 decimal places ?', 'Invalid decimal places', (value) =>
                value ? countDecimal(expoToString(Number(value))) <= Number(pairFees?.price_decimal) : true,
            )
            .test(
                'oneFieldOnly',
                'Please enter either amount or units, not both unless one is zero',
                function (value) {
                    const units = this.parent.units;
                    // Allow both fields if one of them is 0, otherwise show an error if both are non-zero and non-empty
                    return !(value > 0 && units > 0); // Return false if both are filled with non-zero values
                },
            ),

        units: Yup.string()
            .test('units', "Units can't be empty", function (value) {
                const amount = this.parent.amount;
                // Allow 0 in 'units' if 'amount' has a valid value
                return (amount && amount > 0) || value !== undefined;
            })
            .test('isPositive', 'Enter a valid amount', function (value) {
                const amount = this.parent.amount;
                // Allow 0 if amount has a value, otherwise check if value is positive
                return (amount && amount > 0) || value > 0;
            })
            .test('isPriceFilled', 'Enter the price first', function () {
                return formRef?.current?.values?.price !== '';
            })
            .test('Is less than 3 decimal places ?', 'Invalid decimal places', (value) =>
                value
                    ? countDecimal(expoToString(Number(value))) <= Number(pairFees?.quantity_decimal)
                    : true,
            )
            .test(
                'oneFieldOnly',
                'Please enter either amount or units, not both unless one is zero',
                function (value) {
                    const amount = this.parent.amount;
                    // Allow both fields if one of them is 0, otherwise show an error if both are non-zero and non-empty
                    return !(amount > 0 && value > 0); // Return false if both are filled with non-zero values
                },
            ),
    });
    const unitsData = issuerData?.rows?.find((e) => e.side === side);
    const timePeriod = timePeriodOptions.find((e) => e.value === unitsData?.time);

    const submitValues = async (values) => {
        let data = values;
        if (isEdit) {
            data = { ...data, id: unitsData?.id };
            const res = await setPairNotify(data)
            if (res.status === 200) {
                setActiveStep((value) => value + 1)
                getPairNotification()
            }

        } else {
            const res = await setPairNotify(data)
            if (res.status === 200) {
                setActiveStep((value) => value + 1)
                getPairNotification()
            }
        }
    };
    useEffect(() => {
        if (isEdit) {
            formRef.current.setFieldValue('units', unitsData?.units);
            formRef.current.setFieldValue('amount', unitsData?.amount);
            formRef.current.setFieldValue('time', timePeriod?.value);
        }
        else {
            formRef.current.setFieldValue('units', '');
            formRef.current.setFieldValue('amount', '');
            formRef.current.setFieldValue('time', timePeriodOptions[0]?.value);
        }
    }, [isEdit, issuerData, side]);
    return (
        <>
            <div className="order-preview">
                <Formik
                    innerRef={formRef}
                    initialValues={{
                        side: options[0]?.value,
                        amount: "",
                        time: timePeriodOptions[0]?.value,
                        units: "",
                        pairName: `${auction?.symbol}_USD`,
                    }} Buy
                    validationSchema={validationSchema}
                    onSubmit={(values) => {
                        submitValues({
                            ...values,
                            amount:
                                Number(values.units) && Number(values.amount)
                                    ? 0
                                    : Number(values?.amount)
                                        ? Number(values?.amount)
                                        : 0,
                            units:
                                Number(values.units) && Number(values.amount)
                                    ? Number(values?.units)
                                    : Number(values?.units)
                                        ? Number(values?.units)
                                        : 0,
                        });
                    }}
                >
                    {({ values, setFieldValue }) => (
                        <Form className="order-form">


                            <CMBox className="orderField">

                                <Row>
                                    <Col lg={6}>
                                        <div className="units-column greenInput">
                                            <div className="label-column">
                                                <label htmlFor="priceType">Side</label>
                                            </div>
                                            <div className="combined-input-container d-flex">
                                                <input
                                                    type="text"
                                                    className="text-input"
                                                    style={{
                                                        backgroundColor:
                                                            values.side === 0 ? "#429800" : "red",
                                                    }}
                                                    disabled
                                                />

                                                <Field name="side">
                                                    {({ field }) => (
                                                        <Dropdown
                                                            {...field}
                                                            options={options}
                                                            value={values?.side}
                                                            isFormikControl={false}
                                                            onChange={(e) => {
                                                                setFieldValue("side", e.target.value)
                                                                setSide(e.target.value)
                                                            }
                                                            }
                                                            className="buyDropdown"
                                                        />
                                                    )}
                                                </Field>
                                                <ErrorMessage
                                                    name="side"
                                                    component="div"
                                                    className="error"
                                                />
                                            </div>
                                        </div>
                                    </Col>
                                    <Col lg={6}>
                                        <div className="units-column">
                                            <div className="label-column">
                                                <label htmlFor="priceType">Time</label>
                                            </div>
                                            <div className="input-column">
                                                <Field name="time">
                                                    {({ field }) => (
                                                        <Dropdown
                                                            {...field}
                                                            options={timePeriodOptions}
                                                            value={values.time}
                                                            isFormikControl={false}
                                                            onChange={(e) => {
                                                                setFieldValue(
                                                                    "time",
                                                                    e.target.value
                                                                );

                                                            }}
                                                            className="priceType"
                                                        />
                                                    )}
                                                </Field>
                                                <ErrorMessage
                                                    name="time"
                                                    component="div"
                                                    className="error"
                                                />
                                            </div>
                                        </div>
                                    </Col>
                                    <Col lg={6}>
                                        <div className="units-column">
                                            <div className="label-column">
                                                <label htmlFor="priceTextInput">Units</label>
                                            </div>
                                            <div className="input-column">
                                                <Field
                                                    placeholder="Enter Units"
                                                    type="text"
                                                    id="units"
                                                    name="units"
                                                    className="limitTextInput custom-form-control"
                                                    maxLength={10}
                                                    style={{ border: "1px solid #ddd" }}
                                                    autoComplete="off"
                                                    onPaste={(e) => {
                                                        e.preventDefault();
                                                    }}
                                                    onKeyUp={(event) =>
                                                        isNumberWithoutDot(event) && event.preventDefault()
                                                    }
                                                    onKeyDown={(evt) =>
                                                        isNumberWithoutDot(evt) && evt.preventDefault()
                                                    }
                                                />
                                            </div>
                                            <ErrorMessage
                                                name="units"
                                                component="div"
                                                className="error"
                                            />
                                        </div>
                                    </Col>
                                    <Col lg={6}>
                                        <div className="units-column">
                                            <div className="label-column">
                                                <label htmlFor="priceTextInput">Amount</label>
                                            </div>
                                            <div className="input-column">
                                                <Field
                                                    placeholder="Enter Amount"
                                                    type="text"
                                                    id="amount"
                                                    name="amount"
                                                    className="limitTextInput custom-form-control"
                                                    maxLength={10}
                                                    style={{ border: "1px solid #ddd" }}
                                                    autoComplete="off"
                                                    onPaste={(e) => {
                                                        e.preventDefault();
                                                    }}
                                                    onKeyUp={(event) =>
                                                        isNumberWithoutDot(event) && event.preventDefault()
                                                    }
                                                    onKeyDown={(evt) =>
                                                        isNumberWithoutDot(evt) && evt.preventDefault()
                                                    }
                                                />
                                            </div>
                                            <ErrorMessage
                                                name="amount"
                                                component="div"
                                                className="error"
                                            />
                                        </div>
                                    </Col>

                                </Row>

                            </CMBox>

                            <CMOffer className="pb-3">
                                <Button
                                    className="btnSize"
                                    type="submit"
                                    color="light-green"
                                    disabled={
                                        pairFees?.last_price === 0 &&
                                            values.selectedPriceOption === "Market" ?
                                            true :
                                            false
                                    }
                                >
                                    Create
                                </Button>
                            </CMOffer>

                        </Form>
                    )}
                </Formik>


            </div>
        </>
    );
};

export default IssuerOrder;
